import { render, staticRenderFns } from "./date-display.vue?vue&type=template&id=6b894ae2&"
import script from "./date-display.vue?vue&type=script&lang=ts&"
export * from "./date-display.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports